import { useEffect } from 'react';
import {
    BrowserRouter,
    Navigate,
    Route,
    Routes
} from "react-router-dom";
import './MainPage.css';

// import * as signalR from '@microsoft/signalr';
import { Login } from '../Module_cms/Auth/Presentation/View/Login';
import { BrandView } from '../Module_cms/Brands/Presentation/View/BrandView';
import { CategoryView } from '../Module_cms/Categories/Presentation/View/CategoryView';
import { ColorView } from '../Module_cms/Colors/Presentation/View/ColorView';
import { CustomerView } from '../Module_cms/Customers/Presentation/View/CustomerView';
import { Home } from '../Module_cms/Home/Presentation/View/Home';
import { AddImages } from '../Module_cms/Products/Presentation/View/AddImages';
import { ProductFormView } from '../Module_cms/Products/Presentation/View/ProductFormView';
import { Products } from '../Module_cms/Products/Presentation/View/Products';
import { SubCategoryView } from '../Module_cms/SubCategories/Presentation/View/SubCategoryView';

import { BannerFormView } from '../Module_cms/Offers_And_Promotions/Presentation/View/banner/BannerFormView';
import { BannerItemDetailFormView } from '../Module_cms/Offers_And_Promotions/Presentation/View/banner/BannerItemDetailFormView';

import { ComplaintBookView } from '../Module_cms/ComplaintBook/Presentation/View/ComplaintBookView';
import { ComplaintBookViewDetail } from '../Module_cms/ComplaintBook/Presentation/View/ComplaintBookViewDetail';
import { FormBuilderTypeOfferImage } from '../Module_cms/Offers_And_Promotions/Presentation/View/typeOffer/images/FormBuilderTypeOfferImage';
import { FormBuilderTypeOfferSlider } from '../Module_cms/Offers_And_Promotions/Presentation/View/typeOffer/slider/FormBuilderTypeOfferSlider';
import { FormBuilderTypeOfferTimer } from '../Module_cms/Offers_And_Promotions/Presentation/View/typeOffer/timer/FormBuilderTypeOfferTimer';
import { TypeOffers } from '../Module_cms/Offers_And_Promotions/Presentation/View/typeOffer/TypeOffers';
import { OrderDetail } from '../Module_cms/Orders/Presentation/View/OrderDetail';
import { Orders } from '../Module_cms/Orders/Presentation/View/Orders';
import { UsersView } from '../Module_cms/Users/Presentation/View/UsersView';
import { PrivateRoute } from './Routes/PrivateRoute';
import Unauthorized from './Unauthorized';
import { ModalFormView } from '../Module_cms/Offers_And_Promotions/Presentation/View/modal/ModalFormView';
import { ModalItemDetailFormView } from '../Module_cms/Offers_And_Promotions/Presentation/View/modal/ModalItemDetailFormView';

 
 
interface StateSidebarProps {
    state: boolean;
}

export default function MainPage({state}: StateSidebarProps){
    useEffect(() => {
    }, []); 

   
    return(
        <>
           <main className={"main-content main-content-" + state}>
           
          
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<Login />} />

                        <Route path="/products" element={<PrivateRoute element={<Products />} allowedRoles={["Administrator"]} />} />
                        <Route path="/new-product" element={<PrivateRoute element={<ProductFormView />} allowedRoles={["Administrator"]} />} />
                        <Route path="/update-product/:id" element={<PrivateRoute element={<ProductFormView />} allowedRoles={["Administrator"]} />} />
                        <Route path="/addimages/:id" element={<PrivateRoute element={<AddImages />} allowedRoles={["Administrator"]} />} />

                        <Route path="/banner-form" element={<PrivateRoute element={<BannerFormView />} allowedRoles={["Administrator"]} />} />
                        <Route path="/banner-detail-form/:id" element={<PrivateRoute element={<BannerItemDetailFormView />} allowedRoles={["Administrator"]} />} />

                        <Route path="/builder-form-images" element={<PrivateRoute element={<FormBuilderTypeOfferImage />} allowedRoles={["Administrator"]} />} />
                        <Route path="/builder-form-slider" element={<PrivateRoute element={<FormBuilderTypeOfferSlider />} allowedRoles={["Administrator"]} />} />
                        <Route path="/builder-form-timer" element={<PrivateRoute element={<FormBuilderTypeOfferTimer />} allowedRoles={["Administrator"]} />} />

                        <Route path="/builder-form-images-update/:id" element={<PrivateRoute element={<FormBuilderTypeOfferImage />} allowedRoles={["Administrator"]} />} />
                        <Route path="/builder-form-slider-update/:id" element={<PrivateRoute element={<FormBuilderTypeOfferSlider />} allowedRoles={["Administrator"]} />} />
                        <Route path="/builder-form-timer-update/:id" element={<PrivateRoute element={<FormBuilderTypeOfferTimer />} allowedRoles={["Administrator"]} />} />


                        <Route path="/type-offers" element={<PrivateRoute element={<TypeOffers />} allowedRoles={["Administrator"]} />} />

                        <Route path="/orders" element={<PrivateRoute element={<Orders />} allowedRoles={["Administrator"]} />} /> 
                        <Route path="/orders-detail/:id" element={<PrivateRoute element={<OrderDetail />} allowedRoles={["Administrator"]} />} />
                        
                        <Route path="/customer" element={<PrivateRoute element={<CustomerView />} allowedRoles={["Administrator"]} />} />
                        <Route path="/users" element={<PrivateRoute element={<UsersView />} allowedRoles={["Administrator"]} />} />
                        <Route path="/libro-reclamaciones" element={<PrivateRoute element={<ComplaintBookView />} allowedRoles={["Administrator"]} />} />
                        <Route path="/detalle-libro-reclamaciones/:id" element={<PrivateRoute element={<ComplaintBookViewDetail />} allowedRoles={["Administrator"]} />} />
                        
                        

                        <Route path="/category" element={<PrivateRoute element={<CategoryView />} allowedRoles={["Administrator"]} />} />
                        <Route path="/subcategory" element={<PrivateRoute element={<SubCategoryView />} allowedRoles={["Administrator"]} />} />
                        <Route path="/brands" element={<PrivateRoute element={<BrandView />} allowedRoles={["Administrator"]} />} />
                        <Route path="/colors" element={<PrivateRoute element={<ColorView />} allowedRoles={["Administrator"]} />} />
                        <Route path="/home" element={<PrivateRoute element={<Home />} allowedRoles={["Administrator"]} />} />

                        <Route path="/modal-form" element={<PrivateRoute element={<ModalFormView />} allowedRoles={["Administrator"]} />} />
                        <Route path="/modal-detail-form/:id" element={<PrivateRoute element={<ModalItemDetailFormView />} allowedRoles={["Administrator"]} />} />

                        <Route path="/unauthorized" element={<Unauthorized />} />
                        <Route path="/" element={<Navigate to="/home" />} />
                        <Route path="*" element={<Navigate to="/home" />} />
                    </Routes>
                </BrowserRouter>
            </main> 
            
        </>
    );
}